// src/components/quote/ProfitGauge.jsx
//
// The "Project profitability" dial in the retail & royalties panel. Hand-built SVG — one
// arc and a needle — like the rest of /quote (BookPreview has no libraries either).
//
// The needle sweeps ±88° for a loss or profit as large as the whole print run; anything
// bigger pins at the end. The arc runs from the on-dark error colour through warning to
// success, because the card is dark purple and those are the variants made for it.

import { tokens } from '../../theme';
import { money } from '../../utils/royalty';

const NEEDLE_SWEEP_DEG = 88;

export default function ProfitGauge({ profit, ratio, lines }) {
  const c = tokens.color;
  return (
    <div className="gauge-card">
      <div className="g-label">Project profitability</div>
      <svg viewBox="0 0 200 118" aria-hidden="true">
        <defs>
          <linearGradient id="rv-gauge-grad" x1="0" x2="1" y1="0" y2="0">
            <stop offset="0" stopColor={c.errorOnDark} />
            <stop offset=".5" stopColor={c.warningOnDark} />
            <stop offset="1" stopColor={c.successOnDark} />
          </linearGradient>
        </defs>
        <path d="M 22 100 A 78 78 0 0 1 178 100" fill="none" stroke="url(#rv-gauge-grad)" strokeWidth="16" strokeLinecap="round" />
        <g className="gauge-needle" style={{ transform: `rotate(${ratio * NEEDLE_SWEEP_DEG}deg)` }}>
          <line x1="100" y1="100" x2="100" y2="38" stroke={c.card} strokeWidth="4" strokeLinecap="round" />
        </g>
        <circle cx="100" cy="100" r="8" fill={c.card} />
      </svg>
      <div className={`g-value ${profit < 0 ? 'neg' : 'pos'}`}>
        {profit < 0 ? '-' : '+'}{money(Math.abs(profit))}
      </div>
      <div className="g-sub">
        {lines.map((line) => <div key={line}>{line}</div>)}
      </div>
    </div>
  );
}
